// Auto-generated by the set-version.js script.
export const FABRIK_WEB_VERSION = '0.1.4'
